import React from 'react';
const TextArea = props => {
  const [fieldProps, setFieldProps] = React.useState({
    id: 1,
    locked: false,
    focussed: false,
    value: '',
    error: '',
    label: props.label,
    placeholder: props.placeholder
  });

  const onChange = event => {
    const value = event.target.value;
    props.setValue(value);
  };

  const fieldClassName = `input-field ${(fieldProps.locked ? fieldProps.focussed : fieldProps.focussed || fieldProps.value) && 'focussed'} ${fieldProps.locked && !fieldProps.focussed && 'locked'} ${props.value !== '' ? 'filled' : ''} rating-textarea`;

  // console.log(fieldProps);

  return (
    <div>
      <div className={fieldClassName} style={{ height: 'auto !important' }}>
        <textarea
          id={1}
          value={props.value}
          placeholder={fieldProps.placeholder}
          onChange={onChange}
          onFocus={() => !fieldProps.locked && setFieldProps(old => ({ ...old, focussed: true }))}
          onBlur={() => !fieldProps.locked && setFieldProps(old => ({ ...old, focussed: false }))}
          style={{ width: '100%' }}
          rows={props.rows || 5}
        >
          {props.value}
        </textarea>
        <label htmlFor={1} className={fieldProps.error && 'error'}>
          {fieldProps.error || fieldProps.label}
        </label>
      </div>
    </div>
  );
};
export default TextArea;
